module.exports = __webpack_public_path__ + "img/logo_login.9e023ddf.png";